import React, { useEffect, useState } from 'react'
import ComparisonListingBanner from './ComparisonListingBanner'
import ComparisonListingCards from './ComparisonListingCards';
import { BaseUrl } from '../../../helper/BaseUrl'
import { fetchJson } from '../../../helper/fetchJson'

export default function ComparisonListing({ initialData }) {
 const [allData, setAllData] = useState(initialData || []);
   // API Calling
  const fetcher = async () => {
    try {
      const result = await fetchJson(`${BaseUrl}/api/comparisons`);
      if (result.comparisons === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setAllData(result.comparisons || []);
    } catch (error) {
      console.error("Fetch error:", error.message);
    }
  };
  useEffect(() => {
    if (!initialData?.length) {
      fetcher();
    }
  }, [initialData]);
  return (
    <>
      <ComparisonListingBanner />
      <ComparisonListingCards data={allData} />
    </>
  )
}
